import {
  academyProfitability,
  calculateTimeLineDataByYears,
  totalAcademySpend,
  clubSpendOnAcademy,
  claculateBenchmarkData,
  claculateROIData,
  getAllMetricsValue,
  calculateRankingForMetrics,
  findRankingWithMetrics,
  fetchRawClubData,
  filterFacility,
  calculateSupportFundData,
  calculateStaffFilteredEntries,
  calculateTotalStaff,
  calculateStaffCost,
  calculateStaffwithZeroSalary,
  calculateStaffQualifiedCoaches,
  calculateFacilityFilteredEntries,
  calculateSelectedFilterDataByYear,
  calculateSelectedFacilityFilterDataByYear,
  calculateTotalPlayer,
  getAverageTimeSpentAcademy,
  calculateInterPlayerCount,
  calculateTeamsFilteredEntries,
  calculateSelectedTeamsFilterDataByYear,
  calculateFinanceFilteredEntries,
  getAcademySpendTotal,
  getSpendTotal,
  calculateAcademyProfitability,
} from './calculationsUtils';
import { OPTIONSENUM, getBenchmarkingSecondLevelOptions } from './filtersOptions';
import { GlobalStoreType, SingleOption, ACTUALBUDGET, SingleValueOption, ClubOption, PAGE } from './typeInterfaces';

// API Responses
export const getFinanceReponse:any = (state: {licenceAnalytics: GlobalStoreType}): [] => {
  return state?.licenceAnalytics?.financeResponse;
};
export const getStaffReponse = (state: {licenceAnalytics: GlobalStoreType}): [] => {
  return state.licenceAnalytics.staffResponse;
};
export const getFacilityResponse = (state: {licenceAnalytics: GlobalStoreType}): [] => {
  return state.licenceAnalytics.facilityResponse;
};

export const getTeamsResponse = (state: {licenceAnalytics: GlobalStoreType}): [] => {
  return state.licenceAnalytics.teamsResponse;
};
export const getPlayersReponse = (state: {licenceAnalytics: GlobalStoreType}): [] => {
  return state.licenceAnalytics.playersResponse;
};
export const getColorsList = (state: {licenceAnalytics: GlobalStoreType}): Record<string, string> => {
  return state.licenceAnalytics.colorsList;
};
export const getSelectedPage:any = (state: {licenceAnalytics: GlobalStoreType}) => {
  return state?.licenceAnalytics?.selectedPage;
};
// Global filter getters
export const getLeagueOptions = (state: {licenceAnalytics: GlobalStoreType}): SingleOption[] => state.licenceAnalytics.globalFilterOptions.league.options;
export const getLeagueValue = (state: {licenceAnalytics: GlobalStoreType}): SingleOption[] => state?.licenceAnalytics?.globalFilterOptions?.league?.value;
export const getRatingOptions = (state: {licenceAnalytics: GlobalStoreType}): SingleOption[] => state.licenceAnalytics.globalFilterOptions.rating.options;
export const getRatingValue = (state: {licenceAnalytics: GlobalStoreType}): SingleValueOption[] => state.licenceAnalytics.globalFilterOptions.rating.value;
export const getYearOptions = (state: {licenceAnalytics: GlobalStoreType}): SingleOption[] => state.licenceAnalytics.globalFilterOptions.year.options;
export const getYearValue:any = (state: {licenceAnalytics: GlobalStoreType}): SingleOption | undefined => state?.licenceAnalytics?.globalFilterOptions?.year?.value;
export const getClubOptions:any = (state: {licenceAnalytics: GlobalStoreType}): ClubOption[] => state?.licenceAnalytics?.globalFilterOptions?.club?.options;
export const getClubValue = (state: {licenceAnalytics: GlobalStoreType}): ClubOption | undefined =>
  typeof state?.licenceAnalytics?.globalFilterOptions?.club?.value === 'string' ? undefined : state?.licenceAnalytics?.globalFilterOptions?.club?.value;
export const getActualBudgetValue:any = (state: {licenceAnalytics: GlobalStoreType}): ACTUALBUDGET => state?.licenceAnalytics?.globalFilterOptions?.actualOrBudget;
export const getSearchValue = (state: {licenceAnalytics: GlobalStoreType}): string => state.licenceAnalytics.globalFilterOptions.search;
export const getPlayersCount = (state: {licenceAnalytics: GlobalStoreType}): string => state.licenceAnalytics.playersCountResponse;
export const getLeaguesHistory = (state: {licenceAnalytics: GlobalStoreType}): string => state?.licenceAnalytics?.leaguesHistory;
export const getFilteredLeaguesHistory:any = (state: {licenceAnalytics: GlobalStoreType}) => {
  const yearValue = getYearValue(state);
  const leagues = getLeagueValue(state);
  const leaguesHistory: any = getLeaguesHistory(state);
  const club = getClubValue(state);
  const clubByYear: any = leaguesHistory?.find((x: any) => x?.year == yearValue?.id);
  if (club && club?.id) {
    return [club?.id];
  } else if (leagues?.length > 0) {
    const leagueIds = leagues?.map(league => league.id);
    const clubIds = clubByYear?.leagues?.flatMap((league:any) => (leagueIds.includes(league.leagueId) ? league.clubs : []));
    return clubIds;
  } else {
    const clubIds = clubByYear?.leagues?.flatMap((league:any) => league.clubs);
    return clubIds;
  }
};
export const getFilteredLeaguesHistoryAll = (state: {licenceAnalytics: GlobalStoreType}) => {
  const yearValue = getYearValue(state);
  const leagues = getLeagueValue(state);
  const leaguesHistory: any = getLeaguesHistory(state);
  const club = getClubValue(state);
  const clubByYear: any = leaguesHistory.find((x: any) => x.year == yearValue?.id);
  const leaguesHistoryAll:any = {};
  if (club && club?.id) {
    leaguesHistoryAll['club'] = [club?.id];
  }
  if (leagues?.length > 0) {
    const leagueIds = leagues?.map(league => league.id);
    const clubIds = clubByYear?.leagues?.flatMap((league:any) => (leagueIds.includes(league.leagueId) ? league.clubs : []));
    leaguesHistoryAll['leagues'] = clubIds;
  }
  const clubIds = clubByYear?.leagues?.flatMap((league:any) => league.clubs);
  leaguesHistoryAll['all'] = clubIds;
  return leaguesHistoryAll;
};
export const getFilteredLeaguesHistoryClub = (state: {licenceAnalytics: GlobalStoreType}) => {
  const yearValue = getYearValue(state);
  const leagues = getLeagueValue(state);
  const leaguesHistory: any = getLeaguesHistory(state);
  const clubByYear: any = leaguesHistory.find((x: any) => x.year == yearValue?.id);
  const leaguesHistoryClub:any = {};
  if (leagues?.length > 0) {
    leagues?.forEach((league:any) => {
      const clubIds = clubByYear?.leagues
        .filter((l:any) => l.leagueId === league.id) // find leagues matching the leagueId
        .flatMap((l:any) => l.clubs); // flatten the clubs for the matched leagues
      
      if (clubIds?.length > 0) {
        leaguesHistoryClub[league.id] = clubIds; // assign clubs to the corresponding league id
      }
    });
  }
  return leaguesHistoryClub;
};
export const fetchClubIdsByStaticData = (state: {licenceAnalytics: GlobalStoreType}, year:any) => {
  const yearValue = year ? year : getYearValue(state);
  const leagues = getLeagueValue(state);
  const leaguesHistory: any = getLeaguesHistory(state);
  const club = getClubValue(state);
  const clubByYear: any = leaguesHistory.find((x: any) => x.year == yearValue?.id);
  if (club && club?.id) {
    return [club?.id];
  } else if (leagues?.length > 0) {
    const leagueIds = leagues?.map((league:any) => league.id);
    const clubIds = clubByYear?.leagues?.flatMap((league:any) => (leagueIds.includes(league.leagueId) ? league.clubs : []));
    return clubIds;
  } else {
    const clubIds = clubByYear?.leagues?.flatMap((league:any) => league.clubs);
    return clubIds;
  }
};
// Ranking getter methods
export const getRankingLables = (state: {licenceAnalytics: GlobalStoreType}): any => {
  if (getSelectedPage(state) == PAGE.STAFF) {
    return state.licenceAnalytics.staffRanking.rankingLabels;
  } else if (getSelectedPage(state) == PAGE.FACILITIES) {
    return state.licenceAnalytics.facilityRanking.rankingLabels;
  } else if (getSelectedPage(state) == PAGE.TEAMS) {
    return state.licenceAnalytics.teamsRanking.rankingLabels;
  } else if (getSelectedPage(state) == PAGE.PLAYERS) {
    return state.licenceAnalytics.playersRanking.rankingLabels;
  }
  return state.licenceAnalytics.ranking.rankingLables;
};
// Timeline getter methods
export const getTimeLineValue = (state: {licenceAnalytics: GlobalStoreType}): SingleOption | undefined => state.licenceAnalytics.timeLineData.timeLine.value;
export const getTimeLineSecondValue = (state: {licenceAnalytics: GlobalStoreType}): SingleOption | undefined =>
  typeof state.licenceAnalytics.timeLineData.timeLine.secondValue === 'string' ? undefined : state.licenceAnalytics.timeLineData.timeLine.secondValue;
// Ranking getter method
export const getRanking = (state: {licenceAnalytics: GlobalStoreType}): any => state.licenceAnalytics.ranking.rank;
// ROI getter methods
export const getRoiInvestmentValue = (state: {licenceAnalytics: GlobalStoreType}): SingleOption | undefined =>
  state.licenceAnalytics.roiData.roiInvestment.value;
export const getRoiInvestmentSecondValue = (state: {licenceAnalytics: GlobalStoreType}): SingleOption | undefined =>
  typeof state.licenceAnalytics.roiData.roiInvestment.secondValue === 'string' ? undefined : state.licenceAnalytics.roiData.roiInvestment.secondValue;
export const getRoiReturnValue = (state: {licenceAnalytics: GlobalStoreType}): SingleOption | undefined => state.licenceAnalytics.roiData.roiReturn.value;
// Benchmarking getter methods
export const getBenchmarkingValue = (state: {licenceAnalytics: GlobalStoreType}): SingleOption | undefined =>
  state.licenceAnalytics.benchmarkingData.benchmarking.value;
export const getBenchmarkingSecondOptions = (state: {licenceAnalytics: GlobalStoreType}) =>
  getBenchmarkingSecondLevelOptions(state.licenceAnalytics.selectedPage, state.licenceAnalytics.benchmarkingData.benchmarking.value?.id);
export const getSelectedClubDataInExploreAcademyExpenseIncome = (state: {licenceAnalytics: GlobalStoreType}): any =>
  state.licenceAnalytics.explorePage.academyExpenseIncome;

const getTabResponse = (state: {licenceAnalytics: GlobalStoreType}) => {
  if (getSelectedPage(state) == PAGE.STAFF) {
    return getStaffReponse(state);
  } else if (getSelectedPage(state) == PAGE.FACILITIES) {
    return getFacilityResponse(state);
  } else if (getSelectedPage(state) == PAGE.TEAMS) {
    return getTeamsResponse(state);
  } else if (getSelectedPage(state) == PAGE.PLAYERS) {
    return getPlayersReponse(state);
  }
  return getFinanceReponse(state);
};

export const getTimeLineDataByYears = (
  state: {licenceAnalytics: GlobalStoreType} | any,
  t:any,
):
  | {
      years: string[];
      series: {
        name: string;
        data: number[];
      }[];
      colors: string[];
    }
  | undefined => {
  let tab = getSelectedPage(state);
  const yearValue = getYearValue(state);
  const leagues = getLeagueValue(state);
  const club = getClubValue(state);
  const ratings = getRatingValue(state);
  let firstFilter: any = getTimeLineValue(state);
  const secondFilter = getTimeLineSecondValue(state);
  const colorsList = getColorsList(state);
  const filteredClubIds = getFilteredLeaguesHistory(state);
  let response = getTabResponse(state);
  if (!response) {
    return;
  }

  if ((tab == PAGE.FACILITIES && OPTIONSENUM.FACILITESCOSTS == firstFilter?.id.toString()) ?? '') {
    tab = PAGE.FINANCE;
    response = getFinanceReponse(state);
    firstFilter = { id: OPTIONSENUM.FACILITIES };
  }

  if ((tab == PAGE.STAFF && OPTIONSENUM.STAFFCOSTS == firstFilter?.id.toString()) ?? '') {
    tab = PAGE.FINANCE;
    response = getFinanceReponse(state);
    firstFilter = { id: OPTIONSENUM.LABOURCOST };
  }

  const data = calculateTimeLineDataByYears(
    tab,
    yearValue,
    leagues,
    club,
    ratings,
    firstFilter?.id.toString() ?? '',
    secondFilter?.id.toString() ?? '',
    response,
    getActualBudgetValue(state),
    colorsList,
    t,
    filteredClubIds,
    state,
  );
  return data;
};

export const getRankingData = (
  state: {licenceAnalytics: GlobalStoreType} | any,
  t:any,
):
  | {
      series: {
        name: string;
        data: number[];
      }[];
      colors: string[];
    }
  | undefined => {
  const tab = getSelectedPage(state);
  const leagues = getLeagueValue(state);
  const clubValue = getClubValue(state);
  const ratings = getRatingValue(state);
  const yearValue = getYearValue(state);
  const year = yearValue?.id;
  const colorsList = getColorsList(state);
  const filteredClubIds = getFilteredLeaguesHistoryAll(state);
  const leaguesHistoryClub: any = getFilteredLeaguesHistoryClub(state);
  const allClubs = getClubOptions(state);

  // Get all clubs's metrics value
  const clubWithMetrics: any[] = [];
  allClubs?.map((club:any) => {
    const result = getAllMetricsValue(
      tab,
      club,
      getTabResponse(state),
      year,
      getActualBudgetValue(state),
      getRankingLables(state),
      filteredClubIds['club'],
    );
    const clubOrLeagueList = calculateFacilityFilteredEntries(leagues, club, ratings, getFinanceReponse(state));
    result[OPTIONSENUM.FACILITESCOSTS] = calculateSelectedFilterDataByYear(
      clubOrLeagueList,
      yearValue?.id,
      OPTIONSENUM.FACILITIES,
      '',
      ACTUALBUDGET.ACTUAL,
      true,
      filteredClubIds['club'],
    );
    clubWithMetrics.push(result);
  });
  const clubWithRankings =
    clubWithMetrics.length > 0 ? findRankingWithMetrics(clubWithMetrics, getRankingLables(state)) : [];
  // Calculate Ranking based on filters
  const rankingResult =
    clubWithRankings &&
    calculateRankingForMetrics(
      tab,
      clubWithRankings,
      clubValue,
      leagues,
      ratings,
      colorsList,
      getRankingLables(state),
      t,
      leaguesHistoryClub,
    );
  return rankingResult;
};

// Filter and calculate total academy spend average
export const getTotalAcademySpend = (state: {licenceAnalytics: GlobalStoreType}): {} => {
  const tab = getSelectedPage(state);
  const yearValue = getYearValue(state);
  const leagues = getLeagueValue(state);
  const club = getClubValue(state);
  const ratings = getRatingValue(state);
  const response = getTabResponse(state);
  const filteredClubIds = getFilteredLeaguesHistory(state);
  return (
    response &&
    totalAcademySpend(tab, club, leagues, ratings, yearValue, response, filteredClubIds, getActualBudgetValue(state))
  );
};
export const getAcademyProfitability = (state: {licenceAnalytics: GlobalStoreType}): {} => {
  const tab = getSelectedPage(state);
  const yearValue = getYearValue(state);
  const leagues = getLeagueValue(state);
  const club = getClubValue(state);
  const ratings = getRatingValue(state);
  const response = getTabResponse(state);
  const filteredClubIds = getFilteredLeaguesHistory(state);
  return (
    response &&
    academyProfitability(tab, club, leagues, ratings, yearValue, response, filteredClubIds, getActualBudgetValue(state))
  );
};
export const getClubSpendOnAcademy = (state: {licenceAnalytics: GlobalStoreType}): {} => {
  const tab = getSelectedPage(state);
  const yearValue = getYearValue(state);
  const leagues = getLeagueValue(state);
  const club = getClubValue(state);
  const ratings = getRatingValue(state);
  const response = getTabResponse(state);
  const filteredClubIds = getFilteredLeaguesHistory(state);
  return (
    response &&
    clubSpendOnAcademy(tab, club, leagues, ratings, yearValue, response, filteredClubIds, getActualBudgetValue(state))
  );
};

export const getBenchmarkingData = (
  state: {licenceAnalytics: GlobalStoreType},
  departments: [],
): [{ x: string; y: number[] }[], { x: string; y: number }[]] => {
  let tab = getSelectedPage(state);
  const yearValue = getYearValue(state);
  const leagues = getLeagueValue(state);
  const club = getClubValue(state);
  const ratings = getRatingValue(state);
  let response = getTabResponse(state);
  let firstFilter: any = getBenchmarkingValue(state);
  let subFilter: any = [
    ...getBenchmarkingSecondOptions(state),
    ...(tab === PAGE.STAFF &&
    departments.length > 0 &&
    (firstFilter?.id.toString() == OPTIONSENUM.TOTALSTAFF || firstFilter?.id.toString() == OPTIONSENUM.AVERAGESALARY)
      ? departments
      : []),
  ];
  // Create a reversed copy of the subFilter array
  if ((tab == PAGE.FACILITIES && OPTIONSENUM.FACILITESCOSTS == firstFilter?.id.toString()) ?? '') {
    tab = PAGE.FINANCE;
    response = getFinanceReponse(state);
    firstFilter = { id: OPTIONSENUM.FACILITIES };
  }
  return claculateBenchmarkData(
    tab,
    yearValue,
    leagues,
    club,
    ratings,
    firstFilter,
    tab == PAGE.FINANCE ? subFilter : subFilter.reverse(),
    response,
    getActualBudgetValue(state),
    getClubOptions(state),
    getFilteredLeaguesHistory(state),
  );
};

export const getROIData = (state: {licenceAnalytics: GlobalStoreType}, t: (string:any) => string) => {
  let tab = getSelectedPage(state);
  const yearValue = getYearValue(state);
  const leagues = getLeagueValue(state);
  const selectedClub = getClubValue(state);
  const ratings = getRatingValue(state);
  let response = getTabResponse(state);
  const allClubs = getClubOptions(state);
  const xaxis = getRoiReturnValue(state);
  const subyaxis = getRoiInvestmentSecondValue(state);
  let yaxis: any = getRoiInvestmentValue(state);
  const actualBudget = getActualBudgetValue(state);
  const playersData = getPlayersDataROI(state);
  const teamsData = getTeamsDataROI(state);
  const filteredClubIds = getFilteredLeaguesHistoryAll(state);
  if ((tab == PAGE.FACILITIES && OPTIONSENUM.FACILITESCOSTS == yaxis?.id.toString()) ?? '') {
    tab = PAGE.FINANCE;
    response = getFinanceReponse(state);
    yaxis = { id: OPTIONSENUM.FACILITIES };
  }
  return claculateROIData(
    tab,
    yearValue,
    leagues,
    selectedClub,
    ratings,
    actualBudget,
    allClubs,
    response,
    xaxis,
    subyaxis,
    yaxis as SingleOption,
    playersData,
    teamsData,
    t,
    filteredClubIds,
  );
};

export const getRawClubData = (state: {licenceAnalytics: GlobalStoreType}): any => {
  const tab = getSelectedPage(state);
  const yearValue = getYearValue(state);
  const leagues = getLeagueValue(state);
  const selectedClub = getClubValue(state);
  const ratings = getRatingValue(state);
  const financeResponse = getFinanceReponse(state);
  const allClubs = getClubOptions(state);
  const filteredClubIds = getFilteredLeaguesHistory(state);
  const result = fetchRawClubData(
    tab,
    yearValue,
    leagues,
    selectedClub,
    ratings,
    financeResponse,
    allClubs,
    filteredClubIds,
  );
  return result;
};

export const getFacilitiesData = (state: {licenceAnalytics: GlobalStoreType}): any => {
  const yearValue = getYearValue(state);
  const leagues = getLeagueValue(state);
  const selectedClub = getClubValue(state);
  const ratings = getRatingValue(state);
  const facilityResponse = state.licenceAnalytics.facilityResponse;
  const actualBudget = getActualBudgetValue(state);
  const filteredClubIds = getFilteredLeaguesHistory(state);

  return filterFacility(yearValue, leagues, selectedClub, ratings, actualBudget, filteredClubIds, facilityResponse);
};
export const getStaffData = (state: {licenceAnalytics: GlobalStoreType}): any => {
  const yearValue = getYearValue(state);
  const leagues = getLeagueValue(state);
  const selectedClub = getClubValue(state);
  const ratings = getRatingValue(state);
  const staffResponse = state.licenceAnalytics.staffResponse;
  const actualBudget = getActualBudgetValue(state);
  const filteredClubIds = getFilteredLeaguesHistory(state);

  return calculateStaffFilteredEntries(
    yearValue?.name,
    leagues,
    selectedClub,
    ratings,
    actualBudget,
    filteredClubIds,
    staffResponse,
  );
};
export const getPlayersData = (state: {licenceAnalytics: GlobalStoreType}): any => {
  const yearValue = getYearValue(state);
  const leagues = getLeagueValue(state);
  const selectedClub = getClubValue(state);
  const ratings = getRatingValue(state);
  const staffResponse = state.licenceAnalytics.playersResponse;
  const actualBudget = getActualBudgetValue(state);
  const filteredClubIds = getFilteredLeaguesHistory(state);

  return calculateStaffFilteredEntries(
    yearValue?.name,
    leagues,
    selectedClub,
    ratings,
    actualBudget,
    filteredClubIds,
    staffResponse,
  );
};

export const getPlayersDataROI = (state: {licenceAnalytics: GlobalStoreType}): any => {
  const yearValue = getYearValue(state);
  const leagues = getLeagueValue(state);
  const ratings = getRatingValue(state);
  const selectedClub = getClubValue(state);
  const staffResponse = state.licenceAnalytics.playersResponse;
  const actualBudget = getActualBudgetValue(state);
  const filteredClubIds = getFilteredLeaguesHistoryAll(state);

  const data:any = {};
  if (selectedClub) {
    data['club'] = calculateStaffFilteredEntries(
      yearValue?.name,
      [],
      selectedClub,
      [],
      actualBudget,
      filteredClubIds['club'],
      staffResponse,
    );
  }
  if (leagues?.length > 0 || ratings?.length > 0) {
    data['leagues'] = calculateStaffFilteredEntries(
      yearValue?.name,
      leagues,
      undefined,
      ratings,
      actualBudget,
      filteredClubIds['leagues'],
      staffResponse,
    );
  }
  data['all'] = calculateStaffFilteredEntries(
    yearValue?.name,
    [],
    undefined,
    [],
    actualBudget,
    filteredClubIds['all'],
    staffResponse,
  );
  return data;
};

export const getSupportFundData = (state: {licenceAnalytics: GlobalStoreType}) => {
  const yearValue = getYearValue(state);
  const leagues = getLeagueValue(state);
  const selectedClub = getClubValue(state);
  const ratings = getRatingValue(state);
  const supportFundResponse = state.licenceAnalytics.supportFundResponse;
  const actualBudget = getActualBudgetValue(state);
  const filteredClubIds = getFilteredLeaguesHistory(state);
  return calculateSupportFundData(
    yearValue,
    leagues,
    selectedClub,
    ratings,
    actualBudget,
    filteredClubIds,
    supportFundResponse,
  );
};
export const getTeamsData = (state: {licenceAnalytics: GlobalStoreType}) => {
  const yearValue = getYearValue(state);
  const leagues = getLeagueValue(state);
  const selectedClub = getClubValue(state);
  const ratings = getRatingValue(state);
  const teamsResponse = getTeamsResponse(state);
  const actualBudget = getActualBudgetValue(state);
  const filteredClubIds = getFilteredLeaguesHistory(state);
  return calculateStaffFilteredEntries(
    yearValue?.name,
    leagues,
    selectedClub,
    ratings,
    actualBudget,
    filteredClubIds,
    teamsResponse,
  );
};
export const getTeamsDataROI = (state: {licenceAnalytics: GlobalStoreType}) => {
  const yearValue = getYearValue(state);
  const leagues = getLeagueValue(state);
  const selectedClub = getClubValue(state);
  const ratings = getRatingValue(state);
  const teamsResponse = getTeamsResponse(state);
  const actualBudget = getActualBudgetValue(state);
  const filteredClubIds = getFilteredLeaguesHistoryAll(state);

  const data:any = {};
  if (selectedClub) {
    data['club'] = calculateStaffFilteredEntries(
      yearValue?.name,
      [],
      selectedClub,
      [],
      actualBudget,
      filteredClubIds['club'],
      teamsResponse,
    );
  }
  if (leagues?.length > 0 || ratings?.length > 0) {
    data['leagues'] = calculateStaffFilteredEntries(
      yearValue?.name,
      leagues,
      undefined,
      ratings,
      actualBudget,
      filteredClubIds['leagues'],
      teamsResponse,
    );
  }
  data['all'] = calculateStaffFilteredEntries(
    yearValue?.name,
    [],
    undefined,
    [],
    actualBudget,
    filteredClubIds['all'],
    teamsResponse,
  );
  return data;
};
// Staff Calculations
export const getTotalStaff = (state: {licenceAnalytics: GlobalStoreType}) => {
  const yearValue = getYearValue(state);
  const leagues = getLeagueValue(state);
  const selectedClub = getClubValue(state);
  const ratings = getRatingValue(state);
  const staffResponse = getStaffReponse(state);
  const actualBudget = getActualBudgetValue(state);
  const filteredClubIds = getFilteredLeaguesHistory(state);
  return calculateTotalStaff(yearValue, leagues, selectedClub, ratings, actualBudget, filteredClubIds, staffResponse);
};
export const getStaffCost = (state: {licenceAnalytics: GlobalStoreType}) => {
  const yearValue = getYearValue(state);
  const leagues = getLeagueValue(state);
  const selectedClub = getClubValue(state);
  const ratings = getRatingValue(state);
  const financeResponse = getFinanceReponse(state);
  const filteredClubIds = getFilteredLeaguesHistory(state);
  return calculateStaffCost(yearValue, leagues, selectedClub, ratings, filteredClubIds, financeResponse);
};
export const getStaffwithZeroSalary = (state: {licenceAnalytics: GlobalStoreType}) => {
  const yearValue = getYearValue(state);
  const leagues = getLeagueValue(state);
  const selectedClub = getClubValue(state);
  const ratings = getRatingValue(state);
  const staffResponse = getStaffReponse(state);
  const actualBudget = getActualBudgetValue(state);
  const filteredClubIds = getFilteredLeaguesHistory(state);
  return calculateStaffwithZeroSalary(
    yearValue,
    leagues,
    selectedClub,
    ratings,
    actualBudget,
    filteredClubIds,
    staffResponse,
  );
};
export const getStaffQualifiedCoaches = (state: {licenceAnalytics: GlobalStoreType}) => {
  const yearValue = getYearValue(state);
  const leagues = getLeagueValue(state);
  const selectedClub = getClubValue(state);
  const ratings = getRatingValue(state);
  const staffResponse = getStaffReponse(state);
  const actualBudget = getActualBudgetValue(state);
  const filteredClubIds = getFilteredLeaguesHistory(state);
  return calculateStaffQualifiedCoaches(
    yearValue,
    leagues,
    selectedClub,
    ratings,
    actualBudget,
    filteredClubIds,
    staffResponse,
  );
};
export const getFacilitiesCosts = (state: {licenceAnalytics: GlobalStoreType}) => {
  const yearValue = getYearValue(state);
  const leagues = getLeagueValue(state);
  const selectedClub = getClubValue(state);
  const ratings = getRatingValue(state);
  const filteredClubIds = getFilteredLeaguesHistory(state);
  const clubOrLeagueList = calculateFacilityFilteredEntries(leagues, selectedClub, ratings, getFinanceReponse(state));

  return calculateSelectedFilterDataByYear(
    clubOrLeagueList,
    yearValue?.id,
    OPTIONSENUM.FACILITIES,
    '',
    ACTUALBUDGET.ACTUAL,
    true,
    filteredClubIds,
  );
};
export const getTotalPitches = (state: {licenceAnalytics: GlobalStoreType}) => {
  const yearValue = getYearValue(state);
  const leagues = getLeagueValue(state);
  const selectedClub = getClubValue(state);
  const ratings = getRatingValue(state);
  const filteredClubIds = getFilteredLeaguesHistory(state);
  const clubOrLeagueList = calculateFacilityFilteredEntries(leagues, selectedClub, ratings, getFacilityResponse(state));

  return calculateSelectedFacilityFilterDataByYear(
    clubOrLeagueList,
    yearValue?.id,
    OPTIONSENUM.TOTALPITCHES,
    '',
    true,
    filteredClubIds,
  );
};
export const getChangingRooms = (state: {licenceAnalytics: GlobalStoreType}) => {
  const yearValue = getYearValue(state);
  const leagues = getLeagueValue(state);
  const selectedClub = getClubValue(state);
  const ratings = getRatingValue(state);
  const filteredClubIds = getFilteredLeaguesHistory(state);
  const clubOrLeagueList = calculateFacilityFilteredEntries(leagues, selectedClub, ratings, getFacilityResponse(state));

  return calculateSelectedFacilityFilterDataByYear(
    clubOrLeagueList,
    yearValue?.id,
    OPTIONSENUM.CHANGINGROOMS,
    '',
    true,
    filteredClubIds,
  );
};

// Player Calculations
export const getTotalPlayer = (state: {licenceAnalytics: GlobalStoreType}) => {
  const yearValue = getYearValue(state);
  const leagues = getLeagueValue(state);
  const selectedClub = getClubValue(state);
  const ratings = getRatingValue(state);
  const playerResponse = getPlayersReponse(state);
  const actualBudget = getActualBudgetValue(state);
  const filteredClubIds = getFilteredLeaguesHistory(state);
  return calculateTotalPlayer(yearValue, leagues, selectedClub, ratings, actualBudget, filteredClubIds, playerResponse);
};

export const getPlayerAverage = (state: {licenceAnalytics: GlobalStoreType}) => {
  const yearValue = getYearValue(state);
  const leagues = getLeagueValue(state);
  const selectedClub = getClubValue(state);
  const ratings = getRatingValue(state);
  const playerResponse = getPlayersReponse(state);
  const actualBudget = getActualBudgetValue(state);
  const filteredClubIds = getFilteredLeaguesHistory(state);
  return getAverageTimeSpentAcademy(
    yearValue,
    leagues,
    selectedClub,
    ratings,
    actualBudget,
    filteredClubIds,
    playerResponse,
  );
};

export const getInterPlayerCount = (state: {licenceAnalytics: GlobalStoreType}) => {
  const yearValue = getYearValue(state);
  const leagues = getLeagueValue(state);
  const selectedClub = getClubValue(state);
  const ratings = getRatingValue(state);
  const playerResponse = getPlayersReponse(state);
  const actualBudget = getActualBudgetValue(state);
  const filteredClubIds = getFilteredLeaguesHistory(state);
  return calculateInterPlayerCount(
    yearValue,
    leagues,
    selectedClub,
    ratings,
    actualBudget,
    filteredClubIds,
    playerResponse,
  );
};
export const getTotalTeams = (state: {licenceAnalytics: GlobalStoreType}) => {
  const yearValue = getYearValue(state);
  const leagues = getLeagueValue(state);
  const selectedClub = getClubValue(state);
  const ratings = getRatingValue(state);
  const filteredClubIds = getFilteredLeaguesHistory(state);
  const clubOrLeagueList = calculateTeamsFilteredEntries(leagues, selectedClub, ratings, getTeamsResponse(state));

  return calculateSelectedTeamsFilterDataByYear(
    clubOrLeagueList,
    yearValue?.id,
    OPTIONSENUM.TOTALTEAMS,
    '',
    true,
    filteredClubIds,
  );
};

export const getTotalExpenses = (state: {licenceAnalytics: GlobalStoreType}) => {
  const yearValue = getYearValue(state);
  const leagues = getLeagueValue(state);
  const selectedClub = getClubValue(state);
  const ratings = getRatingValue(state);
  const filteredClubIds = getFilteredLeaguesHistory(state);
  const clubOrLeagueList = calculateTeamsFilteredEntries(leagues, selectedClub, ratings, getTeamsResponse(state));

  return calculateSelectedTeamsFilterDataByYear(
    clubOrLeagueList,
    yearValue?.id,
    OPTIONSENUM.TOTALEXPENSES,
    '',
    true,
    filteredClubIds,
  );
};

export const getAdmissionFees = (state: {licenceAnalytics: GlobalStoreType}) => {
  const yearValue = getYearValue(state);
  const leagues = getLeagueValue(state);
  const selectedClub = getClubValue(state);
  const ratings = getRatingValue(state);
  const filteredClubIds = getFilteredLeaguesHistory(state);
  const clubOrLeagueList = calculateTeamsFilteredEntries(leagues, selectedClub, ratings, getTeamsResponse(state));

  return calculateSelectedTeamsFilterDataByYear(
    clubOrLeagueList,
    yearValue?.id,
    OPTIONSENUM.ADMISSIONFEES,
    '',
    true,
    filteredClubIds,
  );
};

export const getYOYTotalStaff = (state: {licenceAnalytics: GlobalStoreType}) => {
  const yearValue: any = getYearValue(state);
  const leagues = getLeagueValue(state);
  const selectedClub = getClubValue(state);
  const ratings = getRatingValue(state);
  const staffResponse = getStaffReponse(state);
  const actualBudget = getActualBudgetValue(state);
  const filteredClubIds = getFilteredLeaguesHistory(state);
  const curYearList = calculateStaffFilteredEntries(
    yearValue?.name,
    leagues,
    selectedClub,
    ratings,
    actualBudget,
    filteredClubIds,
    staffResponse,
  );
  const prevYearList = calculateStaffFilteredEntries(
    (+yearValue?.name - 1).toString(),
    leagues,
    selectedClub,
    ratings,
    actualBudget,
    filteredClubIds,
    staffResponse,
  );

  // Extract unique club ids using a Set
  const curuniqueClubIds = new Set(curYearList.map((item:any) => item.clubId));
  // Get the count of distinct club ids, default to 1 if the set is empty
  const curdistinctClubCount = curuniqueClubIds.size > 0 ? curuniqueClubIds.size : 1;

  // Extract unique club ids using a Set
  const prevuniqueClubIds = new Set(prevYearList.map((item:any) => item.clubId));
  // Get the count of distinct club ids, default to 1 if the set is empty
  const prevdistinctClubCount = prevuniqueClubIds.size > 0 ? prevuniqueClubIds.size : 1;

  // Calculate current year's list length per club
  const curYearCount = calculateCountPerClub(curYearList, curdistinctClubCount);

  // Calculate previous year's list length per club or fallback to 0 if prevYearList is empty
  const prevYearCount = calculateCountPerClub(prevYearList, prevdistinctClubCount);

  // Calculate Year-over-Year (YoY) change
  let yoyValue;
  if (prevYearCount === 0) {
    return (yoyValue = 0);
  } else {
    return (yoyValue = ((curYearCount - prevYearCount) / prevYearCount) * 100); // Calculate percentage change
  }
};
// Helper function to safely calculate count per club
const calculateCountPerClub = (list:any, distinctClubCount:any) => {
  // Avoid division by zero by returning 0 if distinctClubCount is zero
  return distinctClubCount > 0 ? Math.ceil(list.length / distinctClubCount) : 0;
};
export const getYOYStaffCost = (state: {licenceAnalytics: GlobalStoreType}) => {
  const yearValue: any = getYearValue(state);
  const leagues = getLeagueValue(state);
  const selectedClub = getClubValue(state);
  const ratings = getRatingValue(state);
  const financeResponse = getFinanceReponse(state);
  const filteredClubIds = getFilteredLeaguesHistory(state);
  const curYearCount = calculateStaffCost(yearValue, leagues, selectedClub, ratings, filteredClubIds, financeResponse);

  const updatedObject = { ...yearValue };

  // Update the values in the copied object
  updatedObject.name = (+yearValue?.name - 1).toString();
  updatedObject.id = (yearValue?.id - 1).toString();
  const prevYearCount = calculateStaffCost(
    updatedObject,
    leagues,
    selectedClub,
    ratings,
    filteredClubIds,
    financeResponse,
  );

  // Calculate Year-over-Year (YoY) change
  let yoyValue;
  if (prevYearCount === 0) {
    return (yoyValue = 0);
  } else {
    return (yoyValue = ((curYearCount - prevYearCount) / prevYearCount) * 100); // Calculate percentage change
  }
};

export const getYOYQualifiedCoaches = (state: {licenceAnalytics: GlobalStoreType}) => {
  const yearValue: any = getYearValue(state);
  const leagues = getLeagueValue(state);
  const selectedClub = getClubValue(state);
  const ratings = getRatingValue(state);
  const staffResponse = getStaffReponse(state);
  const actualBudget = getActualBudgetValue(state);
  const filteredClubIds = getFilteredLeaguesHistory(state);
  const curYearCount = calculateStaffQualifiedCoaches(
    yearValue,
    leagues,
    selectedClub,
    ratings,
    actualBudget,
    filteredClubIds,
    staffResponse,
  );
  const updatedObject = { ...yearValue };

  // Update the values in the copied object
  updatedObject.name = (+yearValue?.name - 1).toString();
  updatedObject.id = yearValue?.id - 1;
  const prevYearCount = calculateStaffQualifiedCoaches(
    updatedObject,
    leagues,
    selectedClub,
    ratings,
    actualBudget,
    filteredClubIds,
    staffResponse,
  );
  // Calculate Year-over-Year (YoY) change
  if (prevYearCount === 0) {
    return 0;
  } else {
    return ((curYearCount - prevYearCount) / prevYearCount) * 100; // Calculate percentage change
  }
};

export const getYoyValues = (state: {licenceAnalytics: GlobalStoreType}) => {
  const tab = getSelectedPage(state);
  const yearValue: any = getYearValue(state);
  const leagues = getLeagueValue(state);
  const selectedClub = getClubValue(state);
  const ratings = getRatingValue(state);
  const financeResponse = getFinanceReponse(state);
  const actualBudget = getActualBudgetValue(state);
  const filteredClubIds = getFilteredLeaguesHistory(state);

  // Function to calculate filtered data and YoY values
  const calculateYoY = (yearValue: SingleOption) => {
    const updatedObject = { ...yearValue };
    updatedObject.name = (+yearValue?.name - 1).toString();
    updatedObject.id = yearValue?.id - 1;

    const filteredData = calculateFinanceFilteredEntries(
      yearValue,
      leagues,
      selectedClub,
      ratings,
      filteredClubIds,
      financeResponse,
    );

    const curYearCount = getAcademySpendTotal(filteredData, actualBudget);
    const prevfilteredData = calculateFinanceFilteredEntries(
      updatedObject,
      leagues,
      selectedClub,
      ratings,
      filteredClubIds,
      financeResponse,
    );
    const prevYearCount = getAcademySpendTotal(prevfilteredData, actualBudget);

    const academySpendYoY = prevYearCount === 0 ? 0 : ((curYearCount - prevYearCount) / prevYearCount) * 100;

    let academySpendTotal = getAcademySpendTotal(filteredData, actualBudget);
    let clubSpendTotal = getSpendTotal(filteredData, actualBudget);
    let curPercentageSpent = clubSpendTotal > 0 ? (academySpendTotal / clubSpendTotal) * 100 : 0;

    academySpendTotal = getAcademySpendTotal(prevfilteredData, actualBudget);
    clubSpendTotal = getSpendTotal(prevfilteredData, actualBudget);
    let prevPercentageSpent = clubSpendTotal > 0 ? (academySpendTotal / clubSpendTotal) * 100 : 0;

    const clubSpendYoY =
      prevPercentageSpent === 0 ? 0 : ((curPercentageSpent - prevPercentageSpent) / prevPercentageSpent) * 100;

    curPercentageSpent = calculateAcademyProfitability(filteredData, actualBudget);
    prevPercentageSpent = calculateAcademyProfitability(prevfilteredData, actualBudget);

    const acadProbYoY =
      prevPercentageSpent === 0 ? 0 : ((curPercentageSpent - prevPercentageSpent) / prevPercentageSpent) * 100;

    return {
      value1: academySpendYoY,
      value2: clubSpendYoY,
      value3: acadProbYoY,
    };
  };

  return calculateYoY(yearValue);
};

export const getFacilitiesYoyValues = (state: {licenceAnalytics: GlobalStoreType}) => {
  const yearValue: any = getYearValue(state);
  const leagues = getLeagueValue(state);
  const selectedClub = getClubValue(state);
  const ratings = getRatingValue(state);
  const facilityResponse = getFacilityResponse(state);
  const filteredClubIds = getFilteredLeaguesHistory(state);

  // Function to calculate filtered data and YoY values
  const calculateYoY = (yearValue: SingleOption) => {
    const updatedObject = { ...yearValue };
    updatedObject.name = (+yearValue?.name - 1).toString();
    updatedObject.id = yearValue?.id - 1;

    const filteredData = calculateFacilityFilteredEntries(leagues, selectedClub, ratings, facilityResponse);
    const financeFilteredData = calculateFacilityFilteredEntries(
      leagues,
      selectedClub,
      ratings,
      getFinanceReponse(state),
    );

    // Selected Year
    const curYearCount = calculateSelectedFacilityFilterDataByYear(
      filteredData,
      yearValue?.id,
      OPTIONSENUM.CHANGINGROOMS,
      '',
      true,
      filteredClubIds,
    );
    const curYearPitchesCount = calculateSelectedFacilityFilterDataByYear(
      filteredData,
      yearValue?.id,
      OPTIONSENUM.TOTALPITCHES,
      '',
      true,
      filteredClubIds,
    );

    const curYearFacilityCost = calculateSelectedFilterDataByYear(
      financeFilteredData,
      yearValue?.id,
      OPTIONSENUM.FACILITIES,
      '',
      ACTUALBUDGET.ACTUAL,
      true,
      filteredClubIds,
    );

    // Selected Year - 1
    const prevYearCount = calculateSelectedFacilityFilterDataByYear(
      filteredData,
      updatedObject?.id,
      OPTIONSENUM.CHANGINGROOMS,
      '',
      true,
      filteredClubIds,
    );

    const prevYearPitchesCount = calculateSelectedFacilityFilterDataByYear(
      filteredData,
      updatedObject?.id,
      OPTIONSENUM.TOTALPITCHES,
      '',
      true,
      filteredClubIds,
    );

    const prevYearFacilityCost = calculateSelectedFilterDataByYear(
      financeFilteredData,
      updatedObject?.id,
      OPTIONSENUM.FACILITIES,
      '',
      ACTUALBUDGET.ACTUAL,
      true,
      filteredClubIds,
    );

    const changingRoomsYoY = prevYearCount === 0 ? 0 : ((curYearCount - prevYearCount) / prevYearCount) * 100;
    const pitchesYoY =
      prevYearPitchesCount === 0 ? 0 : ((curYearPitchesCount - prevYearPitchesCount) / prevYearPitchesCount) * 100;
    const facilityCostYoY =
      prevYearFacilityCost === 0 ? 0 : ((curYearFacilityCost - prevYearFacilityCost) / prevYearFacilityCost) * 100;

    return {
      value1: facilityCostYoY,
      value2: pitchesYoY,
      value3: changingRoomsYoY,
    };
  };

  return calculateYoY(yearValue);
};

export const getTeamsYoyValues = (state: {licenceAnalytics: GlobalStoreType}) => {
  const yearValue: any = getYearValue(state);
  const leagues = getLeagueValue(state);
  const selectedClub = getClubValue(state);
  const ratings = getRatingValue(state);
  const teamResponse = getTeamsResponse(state);
  const filteredClubIds = getFilteredLeaguesHistory(state);

  // Function to calculate filtered data and YoY values
  const calculateYoY = (yearValue: SingleOption) => {
    const updatedObject = { ...yearValue };
    updatedObject.name = (+yearValue?.name - 1).toString();
    updatedObject.id = yearValue?.id - 1;

    const filteredData = calculateTeamsFilteredEntries(leagues, selectedClub, ratings, teamResponse);

    // Selected Year
    const curYearTeamCount = calculateSelectedTeamsFilterDataByYear(
      filteredData,
      yearValue?.id,
      OPTIONSENUM.TOTALTEAMS,
      '',
      true,
      filteredClubIds,
    );
    const curYearExpenseCount = calculateSelectedTeamsFilterDataByYear(
      filteredData,
      yearValue?.id,
      OPTIONSENUM.TOTALEXPENSES,
      '',
      true,
      filteredClubIds,
    );

    const curYearAdmissionCost = calculateSelectedTeamsFilterDataByYear(
      filteredData,
      yearValue?.id,
      OPTIONSENUM.ADMISSIONFEES,
      '',
      true,
      filteredClubIds,
    );

    // Selected Year - 1
    const prevYearTeamCount = calculateSelectedTeamsFilterDataByYear(
      filteredData,
      updatedObject?.id,
      OPTIONSENUM.TOTALTEAMS,
      '',
      true,
      filteredClubIds,
    );

    const prevYearExpenseCount = calculateSelectedTeamsFilterDataByYear(
      filteredData,
      updatedObject?.id,
      OPTIONSENUM.TOTALEXPENSES,
      '',
      true,
      filteredClubIds,
    );

    const prevYearAdmissionCost = calculateSelectedTeamsFilterDataByYear(
      filteredData,
      updatedObject?.id,
      OPTIONSENUM.ADMISSIONFEES,
      '',
      true,
      filteredClubIds,
    );

    const teamTotalsYoY =
      prevYearTeamCount === 0 ? 0 : ((curYearTeamCount - prevYearTeamCount) / prevYearTeamCount) * 100;
    const expensesYoY =
      prevYearExpenseCount === 0 ? 0 : ((curYearExpenseCount - prevYearExpenseCount) / prevYearExpenseCount) * 100;
    const admissionCostYoY =
      prevYearAdmissionCost === 0 ? 0 : ((curYearAdmissionCost - prevYearAdmissionCost) / prevYearAdmissionCost) * 100;

    return {
      value1: teamTotalsYoY,
      value2: expensesYoY,
      value3: admissionCostYoY,
    };
  };

  return calculateYoY(yearValue);
};

export const getPlayersYoyValues = (state: {licenceAnalytics: GlobalStoreType}) => {
  const yearValue: any = getYearValue(state);
  const leagues = getLeagueValue(state);
  const selectedClub = getClubValue(state);
  const ratings = getRatingValue(state);
  const playerResponse = getPlayersReponse(state);
  const filteredClubIds = getFilteredLeaguesHistory(state);

  // Function to calculate filtered data and YoY values
  const calculateYoY = (yearValue: SingleOption) => {
    const updatedObject = { ...yearValue };
    updatedObject.name = (+yearValue?.name - 1).toString();
    updatedObject.id = yearValue?.id - 1;

    // Selected Year
    const curYearPlayerCount = calculateTotalPlayer(
      yearValue,
      leagues,
      selectedClub,
      ratings,
      ACTUALBUDGET.ACTUAL,
      filteredClubIds,
      playerResponse,
    );
    // Selected Year - 1
    const prevYearPlayerCount = calculateTotalPlayer(
      updatedObject,
      leagues,
      selectedClub,
      ratings,
      ACTUALBUDGET.ACTUAL,
      filteredClubIds,
      playerResponse,
    );

    const curYearTimeCount = getAverageTimeSpentAcademy(
      yearValue,
      leagues,
      selectedClub,
      ratings,
      ACTUALBUDGET.ACTUAL,
      filteredClubIds,
      playerResponse,
    );

    const prevYearTimeCount = getAverageTimeSpentAcademy(
      updatedObject,
      leagues,
      selectedClub,
      ratings,
      ACTUALBUDGET.ACTUAL,
      filteredClubIds,
      playerResponse,
    );

    const curYearInterCost = calculateInterPlayerCount(
      yearValue,
      leagues,
      selectedClub,
      ratings,
      ACTUALBUDGET.ACTUAL,
      filteredClubIds,
      playerResponse,
    );

    const prevYearInterCost = calculateInterPlayerCount(
      updatedObject,
      leagues,
      selectedClub,
      ratings,
      ACTUALBUDGET.ACTUAL,
      filteredClubIds,
      playerResponse,
    );

    const playerTotalYoY =
      prevYearPlayerCount === 0 ? 0 : ((curYearPlayerCount - prevYearPlayerCount) / prevYearPlayerCount) * 100;
    const avgTimeYoY = prevYearTimeCount === 0 ? 0 : ((curYearTimeCount - prevYearTimeCount) / prevYearTimeCount) * 100;
    const interPlayerYoY =
      prevYearInterCost === 0 ? 0 : ((curYearInterCost - prevYearInterCost) / prevYearInterCost) * 100;

    return {
      value1: playerTotalYoY,
      value2: avgTimeYoY,
      value3: interPlayerYoY,
    };
  };

  return calculateYoY(yearValue);
};
